import React from 'react'
import "./Loader.scss"

const Loader = () => {
  return (
    <div className='loader-div'>
        <div className="loader"></div>
    </div>
  )
}

export default Loader